import { ValidateJSModel, ValidateJSModelAttribute } from 'forms/shared/types';
import locationModel from '../location';
import { LocationModel } from '../types';

interface LocationOffenseModel {
  city: LocationModel['city']
  state: LocationModel['state']
  country: LocationModel['country']
  zipcode: LocationModel['zipcode']
}

const locationOffenseModelValidator: ValidateJSModel<LocationOffenseModel> = {
  city: locationModel.city as ValidateJSModelAttribute<LocationOffenseModel, 'city'>,
  state: locationModel.state as ValidateJSModelAttribute<LocationOffenseModel, 'state'>,
  zipcode: locationModel.zipcode as ValidateJSModelAttribute<LocationOffenseModel, 'zipcode'>,
  country: locationModel.country as ValidateJSModelAttribute<LocationOffenseModel, 'country'>,
};

export default locationOffenseModelValidator;
